import { computed } from 'vue';
import { CrudAction, useAuthorization } from '#layers/access/public';
import { useFileCollection } from '#layers/data-model/public';

/** Whether the user may upload files. An upload creates the file through the assets endpoint. */
export function useCanUploadFiles() {
	const { can } = useAuthorization();
	const { collection } = useFileCollection();

	return computed(() => !!collection.value && can({ collection: collection.value, action: CrudAction.Create }));
}
